import { useState } from "react";
import { mockUser } from "../../../mocks/account";
import { Link } from "react-router-dom";

interface ProfileCardProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const tabs = [
  { id: "tickets", label: "Meine Lose", icon: "ri-ticket-2-line" },
  { id: "draw", label: "Ziehungsverfolgung", icon: "ri-bar-chart-line" },
  { id: "history", label: "Verlauf", icon: "ri-history-line" },
  { id: "notifications", label: "Benachrichtigungen", icon: "ri-notification-3-line", badge: 2 },
  { id: "settings", label: "Einstellungen", icon: "ri-settings-3-line" },
];

export default function ProfileCard({ activeTab, onTabChange }: ProfileCardProps) {
  return (
    <aside className="w-full lg:w-72 flex-shrink-0">
      {/* User Info */}
      <div className="bg-white rounded-2xl border border-slate-100 p-6 mb-4">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-secondary to-secondary-light rounded-full flex items-center justify-center text-white font-bold text-2xl mb-3 font-playfair">
            {mockUser.avatar}
          </div>
          <h2 className="font-bold text-slate-900 text-lg">{mockUser.firstName} {mockUser.lastName}</h2>
          <p className="text-slate-500 text-sm">{mockUser.email}</p>
          <span className="mt-2 inline-flex items-center gap-1 bg-emerald-100 text-emerald-700 text-xs font-medium px-3 py-1 rounded-full">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-vip-crown-line text-xs"></i></span>
            Mitglied seit {mockUser.memberSince}
          </span>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3 pt-5 border-t border-slate-100">
          {[
            { val: mockUser.totalTickets, label: "Lose" },
            { val: mockUser.totalDraws, label: "Ziehungen" },
            { val: `${mockUser.totalSpent}€`, label: "Investiert" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-bold text-slate-900 text-lg">{s.val}</p>
              <p className="text-slate-500 text-xs">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`w-full flex items-center justify-between px-5 py-3.5 text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap border-b border-slate-50 last:border-0 ${
              activeTab === tab.id
                ? "bg-sky-50 text-sky-600"
                : "text-slate-600 hover:bg-slate-50"
            }`}
          >
            <div className="flex items-center gap-3">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${tab.icon} text-base`}></i>
              </span>
              {tab.label}
            </div>
            {tab.badge && (
              <span className="bg-primary text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
                {tab.badge}
              </span>
            )}
            {activeTab === tab.id && (
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-secondary"></i>
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Buy More CTA */}
      <Link
        to="/forfaits"
        className="mt-4 flex items-center justify-center gap-2 w-full bg-primary hover:bg-primary-dark text-white font-semibold py-3.5 rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap hover:-translate-y-0.5 shadow-lg hover:shadow-orange-100"
      >
        <span className="w-4 h-4 flex items-center justify-center"><i className="ri-add-line"></i></span>
        Mehr Lose kaufen
      </Link>
    </aside>
  );
}
